module.exports = __webpack_public_path__ + "img/portal-logo.93eb1e13.png";